import { names } from "../../../../Styles/names"
import { changeHotel, isCurrentHotel } from "./functions"

export const ChangeHotelButton = ({ minPrice, hotel }) => {
  const isActive = minPrice && !isCurrentHotel(hotel.url)
  const classNames = (isActive
    ? ["hotellist-modal__hotel-select-btn", names.backgrond.button.negative, names.text.negative]
    : ["hotellist-modal__hotel-select-btn", names.backgrond.button.quaternary, names.text.tertiary])
    .join(' ')

  const id = isActive
    ? "hotellist-modal__hotel-select-btn"
    : "hotellist-modal__hotel-btn-disabled"

  return <button
    id={id}
    className={classNames}
    onClick={() => changeHotel(changeHotel(hotel.url))}
  >
    {isCurrentHotel(hotel.url) ? 'Уже выбран' : !minPrice ? 'Распродано' : 'Выбрать'}
  </button>
}